import { useCurrentRefinements } from 'react-instantsearch-hooks-web';

export default function CurrentRefinements({productSpecials}) {
  const { items, refine } = useCurrentRefinements({
    excludedAttributes: []
  });

  return (
    <>
      {items.length > 0 ?
        <div className="currentRefinements">
          <div className="list">
            {items.map(item => {
              return item.refinements.map(refinement => {
                if (refinement.attribute.includes('price')) {
                  const price = refinement.label.slice(0, 1) + ' $' + refinement.label.slice(2)
                  return <span key={refinement.label} onClick={() => refine(refinement)}>Price {price}</span>
                }
                else if (refinement.attribute.includes('thc')) {
                  return <span key={refinement.label} onClick={() => refine(refinement)}>THC {refinement.label}%</span>
                }
                else if (refinement.attribute.includes('cbd')) {
                  return <span key={refinement.label} onClick={() => refine(refinement)}>CBD {refinement.label}%</span>
                }
                else if (refinement.attribute === "applicable_special_ids") {
                  // filter/find algolia's special IDs to Jane's special title
                  return (
                    productSpecials && productSpecials.map(special => {
                      if (special.id.toString() === refinement.label) {
                        return (
                          <span key={refinement.label} onClick={() => refine(refinement)}>
                            {special.title}
                          </span>
                        )
                      }
                    })
                  )
                }
                else return <span key={refinement.label} onClick={() => refine(refinement)}>
                  {refinement.label.includes(':') ? refinement.label.split(':')[1] : refinement.label}
                  </span>
              })
            })}
          </div>
        </div>
        : null}
    </>
  );
}



// function CurrentRefinementsCount(props) {
//   const { items } = useCurrentRefinements(props);
//   const itemsCount = items.map(item => item.refinements.length)
//   const total = itemsCount.reduce((a, b) => a + b, 0)
//   return (
//     <>
//       {total > 0 ?
//         <div className={styles.currentRefinementsCount}>
//           {total}
//         </div>
//         : null}
//     </>
//   )
// }
